export default __webpack_public_path__ + "317b418ed317e258b17318b4a4c0335e.ttf";